import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadPersonalCVData = () => {
    return {
        type: actionTypes.LOAD_PERSONAL_CV_DATA
    }
}

export const setPersonalCVData = (personalCVData) => {
    return {
        type: actionTypes.SET_PERSONAL_CV_DATA,
        personalCVData: personalCVData
    }
}

export const getPersonalCVData = () => {
    return (dispatch) => {
        dispatch(loadPersonalCVData())
        axios.get(`/api/v1/profiles/personal-cv`)
            .then(response => {
                dispatch(setPersonalCVData(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const loadSkills = () => {
    return {
        type: actionTypes.LOAD_SKILLS
    }
}

export const setSkills = (skillsData) => {
    return {
        type: actionTypes.SET_SKILLS,
        skillsData: skillsData
    }
}

export const getSkills = (name) => {
    return (dispatch) => {
        dispatch(loadSkills)
        axios.get(`/api/v1/skill?name=` + name)
            .then(response => {
                dispatch(setSkills(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const updateSkills = (skills) => {
    return {
        type: actionTypes.UPDATE_SKILLS,
        dto: skills
    }
}

export const updateSkillsRequest = (skills) => {
    return (dispatch) => {
        axios.post(`/api/v1/profiles/my-skills`, skills)
            .then(response => {
                dispatch(updateSkills(skills));
                dispatch(setMessage({type: 'success', text: "Навыки успешно обновлены."}))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось обновить навыки."}))
            });
    }
}

export const sendUpdateSummaryRequest = () => {
    return {
        type: actionTypes.SEND_UPDATE_SUMMARY_REQUEST
    }
}

export const updateSummary = (dto) => {
    return {
        type: actionTypes.UPDATE_SUMMARY,
        dto: dto
    }
}

export const updateSummaryRequest = (dto) => {
    return (dispatch) => {
        axios.put(`/api/v1/profiles/summary`, dto)
            .then(response => {
                dispatch(updateSummary(dto));
                dispatch(setMessage({type: 'success', text: "Основная информация успешно обновлена."}))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось обновить основную информацию."}))
            });
    }
}

export const sendUpdateShowRatingRequest = () => {
    return {
        type: actionTypes.SEND_UPDATE_SHOW_RATING_REQUEST
    }
}

export const updateShowRating = (dto) => {
    return {
        type: actionTypes.UPDATE_SHOW_RATING,
        dto: dto
    }
}

export const updateShowRatingRequest = (dto) => {
    return (dispatch) => {
        axios.put(`/api/v1/profiles/personal-cv-rating`, dto)
            .then(response => {
                dispatch(updateShowRating(dto));
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось изменить статус рейтинга."}))
            });
    }
}

export const sendUpdateJobSearchRequest = () => {
    return {
        type: actionTypes.SEND_UPDATE_JOB_SEARCH_REQUEST
    }
}

export const updateJobSearch = (dto) => {
    return {
        type: actionTypes.UPDATE_JOB_SEARCH,
        dto: dto
    }
}

export const updateJobSearchRequest = (dto) => {
    return (dispatch) => {
        axios.put(`/api/v1/profiles/personal-cv-searching-job`, dto)
            .then(response => {
                dispatch(updateJobSearch(dto));
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось изменить статус поиска работы."}))
            });
    }
}

export const sendUpdatePublishedRequest = () => {
    return {
        type: actionTypes.SEND_UPDATE_PUBLISHED_REQUEST
    }
}

export const updatePublished = (dto) => {
    return {
        type: actionTypes.UPDATE_PUBLISHED,
        dto: dto
    }
}

export const updatePublishedRequest = (dto) => {
    return (dispatch) => {
        axios.put(`/api/v1/profiles/personal-cv-published`, dto)
            .then(response => {
                dispatch(updatePublished(dto));
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось изменить статус профиля."}))
            });
    }
}

export const updatePhoto = (src) => {
    return {
        type: actionTypes.UPDATE_PHOTO,
        src: src
    }
}

export const updatePhotoRequest = (src) => {
    return (dispatch) => {
        axios.post(`/api/v1/profiles/my-photo`, src,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        )
            .then(response => {
                dispatch(updatePhoto(response.data));
                dispatch(setMessage({type: 'success', text: "Фото успешно обновлено."}))
            })
            .catch(error => {
                dispatch(setMessage({type: 'error', text: "Не удалось обновить фото."}))
            });
    }
}

export const updateReferences = (references) => {
    return {
        type: actionTypes.UPDATE_REFERENCES,
        references: references
    }
}

export const updateReferencesRequest = (references) => {
    return (dispatch) => {
        axios.put(`/api/v1/profiles/my-references`, references)
            .then(response => {
                dispatch(updateReferences(references));
                dispatch(setMessage({type: 'success', text: "Ссылки успешно обновлены."}))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось обновить ссылки."}))
            });
    }
}